import { Label, StyledSelect } from "./styled";

import { textChooser } from "../../../util/textChooser";

export interface SelectItem {
  id: string | number;
  label: string;
}

interface ISelect extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: SelectItem[];
  label?: string;
}

export default function Select({ options, label, ...props }: ISelect) {
  return (
    <>
      {label && (
        <Label htmlFor={props.id} className="main-label">
          {label}
        </Label>
      )}

      <StyledSelect {...props}>
        <option>{textChooser('txt235')}</option>
        {options && options.map((item: SelectItem) => <option value={item.id}>{item.label}</option>)}
      </StyledSelect>
    </>
  );
}